export const SIGNING_FLOW_TAG_KEY = 'portal.signing_flow' as const;
export const SIGNING_FLOW_TAG_VALUE = 'signing-flow' as const;

// Intentionally duplicated from flows/* and submissions/* to keep this
// module decoupled — observability should observe, not import domain
// internals. See `__tests__/cookie-name-contract.test.ts` for the
// drift-detection test that keeps these aligned with the source modules.
export const FLOW_TOKEN_COOKIE_PREFIX = '__ftm_' as const;
export const SUBMISSION_TOKEN_COOKIE_NAME = '__submission_token' as const;
